import React from 'react';
import EmptyRecord from '@/components/EmptyRecord';

const NoData = ({
  text = (
    <p>
      您暂时没有权益
      <br />
      请及时关注APP活动哦！
    </p>
  ),
  className,
}) => <EmptyRecord img="monitor/noData.png" text={text} className={className} />;

export default NoData;
